import formGroupIngestServer from './formGroupIngestServer';

export default {
  title: 'Ingest server Creation',
  attributeName: 'ingestServer',
  createURL: 'ingestserver',
  sessionParams: [],
  getURL: 'ingestserver',
  updateURL: 'ingestserver',
  idAttribute: 'id',
  noArea: true,
  goBack: true,
  autoUpdate: true,
  formConfig: [
    formGroupIngestServer,
  ],
};
